import authService from "./web/auth-service.js";

export const SESSION_QUERY_KEY = ["session"];

export const sessionQueryOptions = {
    queryKey: SESSION_QUERY_KEY,
    queryFn: authService.validateToken,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
};
